import { createContext, useContext, useEffect, useState } from "react";
import { login as apiLogin, fetchMe, setAuthToken, getAuthToken } from "@/lib/procureApi";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined); // undefined=checking, null=logged out

  useEffect(() => {
    if (!getAuthToken()) {
      setUser(null);
      return;
    }
    fetchMe().then(setUser).catch(() => {
      setAuthToken(null);
      setUser(null);
    });
  }, []);

  const signIn = async (username, password) => {
    const res = await apiLogin(username, password);
    setAuthToken(res.token);
    setUser(res.user);
    return res.user;
  };

  const signOut = () => {
    setAuthToken(null);
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, signIn, signOut, setUser, isAdmin: user?.role === "admin", isBuyer: user?.role === "buyer" }}>
      {children}
    </AuthCtx.Provider>
  );
};
